import { render, staticRenderFns } from "./MyTest.vue?vue&type=template&id=67d04564&scoped=true"
import script from "./MyTest.vue?vue&type=script&lang=js"
export * from "./MyTest.vue?vue&type=script&lang=js"
import style0 from "./MyTest.vue?vue&type=style&index=0&id=67d04564&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d04564",
  null
  
)

export default component.exports